'use strict';

module.exports = function setAttributes(element, attributes) {
  var value;

  for (var key in attributes) {
    if (attributes.hasOwnProperty(key)) {
      value = attributes[key];

      if (value == null) {
        element.removeAttribute(key);
      } else {
        element.setAttribute(key, value);
      }
    }
  }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@braintree/iframer/lib/set-attributes.js
// module id = 61TQ
// module chunks = 3